module.exports = __webpack_public_path__ + "static/media/0027_IMG_LES_ENSEIGNES_LA_CAVE_SCRABBLE.b597792a.webp";